var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg14 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "14")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.17,38c.3-.15.25-.47.33-.71a6.74,6.74,0,0,1,7.16-4.57,6.66,6.66,0,0,1,5.91,6.52c0,2.57,0,5.14,0,7.7,0,.61.12.79.76.79q25.54,0,51.07,0c2.12,0,4.24,0,6.36,0,.65,0,.77-.19.76-.79,0-2.46,0-4.91,0-7.37A6.7,6.7,0,0,1,87.76,37.9c0,.11,0,.22.17.24V55.73c-.28.13-.22.43-.3.65a6.68,6.68,0,0,1-6.32,4.73c-.64,0-1.29,0-1.92,0s-.87.1-.84.8c.06,1.76,0,3.52,0,5.27a2.71,2.71,0,1,1-5.39-.05c0-1.73,0-3.46,0-5.19,0-.63-.11-.84-.8-.84q-17.29,0-34.58,0H18.14c-1.21,0-1.21,0-1.21,1.25,0,1.65,0,3.29,0,4.94a2.7,2.7,0,1,1-5.39,0c0-1.62,0-3.24,0-4.86,0-1.37,0-1.36-1.33-1.37A14,14,0,0,1,7.87,61a6.6,6.6,0,0,1-5.4-4.65c-.07-.22,0-.52-.3-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45,44.07c-8.32,0-16.63,0-24.95,0-.68,0-.8-.21-.81-.83A29,29,0,0,0,19,37.16a10,10,0,0,0-4.52-6.47A1,1,0,0,1,14,29.47,10.54,10.54,0,0,1,24.43,21q20.68-.06,41.36,0a10.54,10.54,0,0,1,10.35,8.46,1,1,0,0,1-.49,1.29,10.12,10.12,0,0,0-4.75,8.63c0,1.31,0,2.62,0,3.93,0,.66-.17.82-.82.82q-12,0-23.94,0Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg14, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/14.35d52089.svg";
export { ForwardRef as ReactComponent };